import React from "react";
import { Chip } from "@mui/material";
import { isTestStoreFlag } from "../utils/merchantStoreTestFlag";

const TestStoreBadge = ({ store }) => {
  if (!isTestStoreFlag(store)) {
    return null;
  }

  return <Chip label="Test store" size="small" color="warning" data-testid="test-store-badge" />;
};

export default TestStoreBadge;
